import React, { useEffect, useRef } from "react";
import { useWebChatCore } from "../../../../cores/conversations";
import { useMeCore } from "../../../../cores/me";
import { useSocketCore } from "../../../../cores/socket";
import MessageRow from "../MessageRow";
import { WebMessage } from "../../../../cores/conversations/interfaces/api/get-messages";
import SubmitInput from "../SubmitInput";
import ScrollButton from "../scrollButton/ScrollButton";
import ChatMessagesLoadingOverlay from "../ChatMessagesLoadingOverlay";

export default function WebChatForm() {
  const { company, user } = useMeCore();
  const { selected, messages, getMessages, attachments } = useWebChatCore();
  const { sendMessageToChannel } = useSocketCore();
  const ref = useRef<any>(null);

  useEffect(() => {
    getMessages(company?.id!, selected?.id!);
  }, [getMessages, selected, company]);

  useEffect(() => {
    if (ref !== null) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    }
  }, [messages]);

  const onSubmit = (message: string) => {
    if (message) {
      const messageContent: any = {
        content: message,
        type: "text",
        conversationId: selected?.id,
        userId: user?.id!,
        attachments,
      };
      sendMessageToChannel(selected?.room!, messageContent);
    }
  };

  const itsMe = (message: WebMessage) => !!message.from.id;

  return (
    <div className="chat-form-layout d-flex flex-column flex-grow-1 min-h-0 w-100 h-100 position-relative">
      <div className="chat-form-layout__messages min-h-0 overflow-auto backdrop-chat position-relative">
        <ChatMessagesLoadingOverlay />
        {messages.map((message) => (
          <MessageRow
            key={message.id}
            message={message}
            itsMe={itsMe(message)}
          />
        ))}
        <div ref={ref} />
        <ScrollButton reference={ref} />
      </div>
      <div className="chat-form-layout__composer">
        <SubmitInput
          attachments={attachments}
          conversation={selected}
          disableAttachments={selected?.type !== "whatsapp"}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
}
